<script lang="ts">
  import type { Snippet } from "svelte";
  import { router } from "@inertiajs/svelte";
  import { authApi } from "../../lib/api";
  import { authStore, addNotification } from "../../lib/stores";
  import Toast from "../overlay/Toast.svelte";
  import TopNavBar from "./TopNavBar.svelte";
  import PillBottomNav from "./PillBottomNav.svelte";
  import SearchModal from "../overlay/SearchModal.svelte";

  let {
    user = null,
    showNav = true,
    children,
  }: {
    user?: { id: string; name: string; email: string; avatarUrl?: string } | null;
    showNav?: boolean;
    children?: Snippet;
  } = $props();

  let showUserMenu = $state(false);
  let showMobileMenu = $state(false);
  let showSearchModal = $state(false);

  let currentPath = $state(
    typeof window !== "undefined" ? window.location.pathname : ""
  );

  async function handleLogout() {
    try {
      await authApi.logout();
      authStore.logout();
      localStorage.removeItem("auth_token");
      addNotification("success", "로그아웃되었습니다.");
      router.visit("/");
    } catch (error) {
      addNotification("error", "로그아웃에 실패했습니다.");
    }
  }

  function toggleUserMenu(_e?: MouseEvent) {
    showUserMenu = !showUserMenu;
    if (showUserMenu) {
      setTimeout(() => {
        document.addEventListener("click", closeUserMenu);
      }, 0);
    }
  }

  function closeUserMenu() {
    showUserMenu = false;
    document.removeEventListener("click", closeUserMenu);
  }
</script>

<div class="min-h-screen" style="background: var(--bg);">
  {#if showNav}
    <TopNavBar
      {user}
      {currentPath}
      {showUserMenu}
      {showMobileMenu}
      onSearchClick={() => (showSearchModal = true)}
      onToggleUserMenu={toggleUserMenu}
      onToggleMobileMenu={() => (showMobileMenu = !showMobileMenu)}
      onLogout={handleLogout}
    />
  {/if}

  <main class={user && showNav ? "pb-28 md:pb-0" : ""}>
    {@render children?.()}
  </main>

  <Toast />

  {#if showNav && user}
    <PillBottomNav
      {user}
      {currentPath}
      onSearchClick={() => (showSearchModal = true)}
    />
  {/if}

  <SearchModal
    show={showSearchModal}
    onClose={() => (showSearchModal = false)}
  />
</div>
